// React
import { useTranslation } from "react-i18next";

// MUI
import { Typography, TextField, Box } from "@mui/material";

// Styles
import { styles } from "../styles";

// Constants
import { MAX_DETAIL_CHARACTERS } from "Constants/ReasonForVisitConstants";

export const DetailsStep = ({
  isMBS,
  location,
  selectedReasonLabel,
  additionalInfo,
  submit,
  onDetailsChange,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Box sx={styles.summaryContainer}>
        {Boolean(location) && (
          <Box>
            <Typography variant="subtitle2" sx={styles.summaryLabel}>
              {t("availableAppointments.location")}
            </Typography>
            <Typography variant="body1" sx={styles.summaryValue}>
              {location}
            </Typography>
          </Box>
        )}
        {Boolean(selectedReasonLabel) && (
          <Box>
            <Typography variant="subtitle2" sx={styles.summaryLabel}>
              {t("reasonForVisitModal.reasonLabel")}
            </Typography>
            <Typography variant="body1" sx={styles.summaryValue}>
              {selectedReasonLabel}
            </Typography>
          </Box>
        )}
      </Box>
      <Typography sx={styles.heading}>
        {t(
          `${isMBS ? "mbsReasonForVisit" : "reasonForVisitModal"}.provideDetails`
        )}
      </Typography>
      <TextField
        multiline
        rows={5}
        disabled={submit}
        value={additionalInfo}
        onChange={onDetailsChange}
        variant="outlined"
        fullWidth
        label={t("reasonForVisitModal.details")}
        placeholder={t("reasonForVisitModal.enterDetails")}
        slotProps={{
          htmlInput: { maxLength: MAX_DETAIL_CHARACTERS },
        }}
        helperText={`${additionalInfo.length}/${MAX_DETAIL_CHARACTERS} ${t(
          "reasonForVisitModal.characters"
        )}`}
      />
    </>
  );
};
